<!--
    File: Dashboard.vue
-->

<template>
    <v-container>
        <v-row class="pa-3" justify="center">
            <v-card outlined class="pa-0" v-if="login" width="480">
                <v-toolbar class="elevation-0" color="background">
                    <v-toolbar-title>{{title}}</v-toolbar-title>
                </v-toolbar>
                <v-list class="pa-3">
                    <v-subheader>MEMU</v-subheader>
                    <v-list-item-group color="primary">
                    <v-list-item v-for="menu in menus" :key="menu.title" link :to="menu.to">
                        <v-list-item-icon>
                        <v-icon>{{ menu.icon }}</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                        <v-list-item-title>{{ menu.title }}</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                    </v-list-item-group>
                </v-list>
            </v-card>
        </v-row>
    </v-container>
</template>
<script>
export default {
    data () {
        return {
            login: null,
            title: null,
            menus: []
        }
    },
    created () {
        console.clear()
        let json = localStorage.getItem('login')
        if (json) {
            this.login = JSON.parse(json)
        }
        if (this.login == null) {
            this.$router.push('/login')
        }
        else if (this.login.level == 10) {
            this.title = '시스템 관리자 콘솔'
            this.menus = [
                { title: '스튜디오 관리', icon: 'mdi-map-marker', to: '/studio' },
                { title: '운영자 관리', icon: 'mdi-account-cog', to: '/user/list' },
                { title: '수업 관리', icon: 'mdi-school', to: '/lesson' },
                { title: '쿠폰 종류', icon: 'mdi-ticket', to: '/coupon/type' }
            ],
            this.$emit('login', this.login, this.menus)
        }
        else if (this.login.level == 5) {
            this.title = '스튜디오 운영자 콘솔'
            this.menus = [
                { title: '회원 관리', icon: 'mdi-account-search', to: '/user/list' },
                { title: '수업 관리', icon: 'mdi-school', to: '/lesson' },
                { title: '예약 관리', icon: 'mdi-calendar-check', to: '/booking' },
                { title: '수업 스케줄', icon: 'mdi-clock', to: '/schedule' },
                { title: '사용자 쿠폰', icon: 'mdi-account-cash', to: '/user/coupon' },
                { title: '스튜디오 정보', icon: 'mdi-map-marker', to: '/studio/info' }
            ],
            this.$emit('login', this.login, this.menus)
        }
        else {
            localStorage.setItem('login', '')
            alert(this.login.email + '님은 시스템 관리자 또는 스튜디오 운영자가 아닙니다.')
            this.$router.push('/login')
        }
    }
}
</script>
<style scoped>

</style>